<template>
  <div class="basic_wrap">
    <div class="login_bg">
      <div class="back_left" @click="$router.back()" />
      <div class="big_tit">
        {{ $t("register.register") }}
      </div>
<!--      <div class="language" @click="$router.push('/language')">-->
<!--        <img :src="require('../images/language/' + lang + '.png')" />-->
<!--      </div>-->
      <div class="title-img">
        <svg style="height: 32px" viewBox="0 0 164 30"><defs><path id="a" d="M157.725 29.99H.01V.048h157.715z"></path></defs><g fill="none" fill-rule="evenodd"><path d="M160.352 24.069v-.449h.288c.157 0 .371.012.371.204 0 .208-.11.245-.296.245h-.363m0 .315h.192l.447.784h.49l-.494-.816c.255-.019.465-.14.465-.484 0-.427-.295-.565-.793-.565h-.721v1.865h.414v-.784m2.098-.146c0-1.095-.851-1.73-1.8-1.73-.955 0-1.805.635-1.805 1.73s.85 1.733 1.805 1.733c.948 0 1.8-.638 1.8-1.733m-.52 0c0 .798-.587 1.334-1.28 1.334v-.006c-.713.006-1.289-.53-1.289-1.328 0-.797.577-1.331 1.289-1.331.694 0 1.28.534 1.28 1.331" fill="#fff"></path><mask id="b" fill="#fff"><use href="#a"></use></mask><path d="m96.374 5.707.002 19.66h5.552V5.707h-5.554zm-43.677-.026v19.686H58.3V10.086l4.37.014c1.437 0 2.43.345 3.123 1.084.879.936 1.237 2.444 1.237 5.205v8.978h5.427V14.49c0-7.763-4.948-8.81-9.789-8.81h-9.97zm52.617.027v19.659h9.006c4.798 0 6.364-.798 8.057-2.587 1.198-1.256 1.971-4.014 1.971-7.027 0-2.763-.655-5.228-1.797-6.763-2.057-2.745-5.02-3.282-9.445-3.282h-7.792zm5.508 4.28h2.387c3.463 0 5.703 1.556 5.703 5.591 0 4.037-2.24 5.592-5.703 5.592h-2.387V9.989zm-22.453-4.28-4.634 15.58-4.44-15.579-5.993-.001 6.34 19.659h8.003l6.391-19.659H88.37zm38.563 19.659h5.553V5.709l-5.555-.001.002 19.659zm15.564-19.652-7.753 19.645h5.475l1.227-3.472h9.175l1.161 3.472h5.944l-7.812-19.646-7.417.001zM146.1 9.3l3.364 9.204h-6.833l3.47-9.204z" fill="#fff" mask="url(#b)"></path><path d="M16.889 8.985V6.28c.262-.02.528-.033.798-.042 7.4-.232 12.255 6.359 12.255 6.359s-5.244 7.282-10.866 7.282a6.82 6.82 0 0 1-2.187-.35v-8.204c2.88.348 3.46 1.62 5.192 4.508l3.852-3.248s-2.812-3.688-7.552-3.688c-.515 0-1.008.036-1.492.088zm0-8.938V4.09c.265-.021.531-.038.798-.048 10.29-.346 16.995 8.44 16.995 8.44s-7.7 9.364-15.723 9.364c-.735 0-1.424-.068-2.07-.183v2.498c.553.07 1.126.112 1.724.112 7.465 0 12.864-3.812 18.092-8.325.867.694 4.416 2.383 5.145 3.123-4.971 4.16-16.555 7.515-23.123 7.515a18.89 18.89 0 0 1-1.838-.096V30h28.375V.047H16.89zm0 19.482v2.133c-6.905-1.23-8.822-8.408-8.822-8.408s3.316-3.674 8.822-4.269v2.34l-.011-.001c-2.89-.347-5.147 2.353-5.147 2.353s1.265 4.544 5.158 5.852zM4.625 12.943s4.092-6.04 12.264-6.663V4.088C7.838 4.815 0 12.48 0 12.48s4.439 12.833 16.889 14.008V24.16C7.753 23.011 4.625 12.943 4.625 12.943z" fill="#76B900" mask="url(#b)"></path></g></svg>
      </div>
    </div>
    <form class="form">
      <div class="cut_login">
        <router-link to="/login">
          {{ $t("register.signIn") }}
          <div class="line" />
        </router-link>
        <router-link class="cur" to="/register">
          {{ $t("register.signUp") }}
          <div class="line" />
        </router-link>
      </div>
<!--      <div class="item" style="display: flex;align-items: center;" v-if="isPhoneRegister">-->
<!--        &lt;!&ndash; <span class="icon">-->
<!--          <img-->
<!--            src="../images/login/tel.png"-->
<!--            alt=""-->
<!--          >-->
<!--        </span> &ndash;&gt;-->
<!--        <span style="margin-left: 7px">+27</span>-->
<!--        <input v-model.trim="data.mobile" type="numder" @input="change_tp" oninput="value=value.replace(/[\u4E00-\u9FA5]/g,'')" class="inp" :placeholder="$t('register.phoneNumber')" />-->
<!--      </div>-->

      <!-- 手机号输入 -->
      <div class="phone-field">
        <van-field
                v-model.trim="data.mobile"
                type="tel"
                @input="change_tp"
                :formatter="formatNumber"
                :placeholder="$t('Phone Number')"
        >
          <template #left-icon>
            <div class="country-trigger" @click="showCountry = true">
              <!--            <span class="flag">{{ country.flag }}</span>-->
              <span class="code">{{ country.dialCode }}</span>
              <van-icon name="arrow-down" />
            </div>
          </template>
        </van-field>
      </div>

      <!-- 国家选择弹窗 -->
      <van-popup v-model="showCountry" position="right" :style="{ width: '100%', height: '100%' }">
        <div class="country-page">
          <div class="country-header">
            <van-search
                    v-model="keyword"
                    shape="round"
                    placeholder="Search country / code"
            />
          </div>

          <van-index-bar :index-list="indexList" highlight-color="#1989fa">
            <div v-for="(group, letter) in filteredGrouped" :key="letter">
              <van-index-anchor :index="letter" />
              <van-cell
                      v-for="item in group"
                      :key="item.iso2"
                      :title="item.name"
                      :label="item.dialCode"
                      @click="selectCountry(item)"
              >
                <template #icon>
                  <span class="cell-flag">{{ item.flag }}</span>
                </template>
              </van-cell>
            </div>
          </van-index-bar>
        </div>
      </van-popup>



      <div class="item" v-if="!isPhoneRegister">
        <input v-model.trim="data.email"  :placeholder="$t('register.emailEmpty')"/>
      </div>
      <div class="item" style="display: flex;align-items: center;" v-if="!isPhoneRegister">
        <span style="margin-left: 7px">+63</span>
        <input v-model.trim="data.mobile" type="text" @input="change_tp" oninput="value=value.replace(/[\u4E00-\u9FA5]/g,'')" class="inp" :placeholder="$t('register.phoneNumber')" />
      </div>
      <!-- <div class="item">
				<span class="icon">
					<img src="../images/login/p1.png" alt="">
				</span>
				<input type="text" class="inp" v-model.trim="data.name" placeholder="请输入用户名" />
			</div> -->
      <div class="item">
        <!-- <span class="icon">
          <img
            src="../images/login/lock.png"
            alt=""
          >
        </span> -->
        <input v-model.trim="data.password" oninput="value=value.replace(/[ ]/g,'')" :type="password" class="inp" :placeholder="$t('Enter Password')" />
        <!-- <div
          class="eye_bi"
          :class="password == 'text' ? 'eye' : ''"
          @click="showPwd"
        /> -->
      </div>

      <div class="item">
        <input v-model.trim="data.spassword"  oninput="value=value.replace(/[ ]/g,'')" :type="password" class="inp" :placeholder="$t('Re-enter Password')" />
      </div>

      <div class="item">
        <input v-model.trim="data.email" type="text" class="inp" :placeholder="$t('Enter Email')" />
      </div>

      <!-- <div class="item">
        <span class="icon">
          <img
            src="../images/login/lock.png"
            alt=""
          >
        </span>
        <input
          v-model.trim="data.spassword"
          :type="password"
          class="inp"
          :placeholder="$t('register.passwordAgain')"
        >
        <div
          class="eye_bi"
          :class="password == 'text' ? 'eye' : ''"
          @click="showPwd"
        />
      </div> -->

      <!-- 			<div class="item">
				<input type="password" class="inp" v-model.trim="data.paypwd" placeholder="请输入支付密码" />
			</div>
			<div class="item">
				<input type="password" class="inp" v-model.trim="data.confirm_paypwd" placeholder="请再次输入支付密码" />
			</div> -->


      <div v-if="show_sms > 0" class="item">
        <input v-model.trim="data.code" type="text" class="inp" :placeholder="$t('register.code')" style="width:calc(100% - 88px);"/>
        <van-count-down :time="time" class="btn get_captcha" @finish="timeCall">
          <template v-slot="timeData">
            <span @click="sendcode">{{
                timeData.seconds > 0 ? timeData.seconds : $t("register.sendCode")
            }}</span>
          </template>
        </van-count-down>
      </div>
      <div class="item">
        <!-- <span class="icon">
          <img
            src="../images/login/p2.png"
            class="people"
            alt=""
          >
        </span> -->
        <input v-model.trim="data.t_mobile" type="text" class="inp" :placeholder="$t('register.referralCode')" />
      </div>
      <div class="item">
        <input v-model.trim="data.captcha_code" type="text" class="inp" :placeholder="$t('CAPTCHA')" style="width:calc(100% - 88px);"/>
        <div>
          <img style="width: 80px;height: 40px;border-radius: 5px;" :src="captchaImage" @click="refreshCaptcha" alt="CAPTCHA" />
        </div>
      </div>

<!--      <div class="item other" v-if="isPhoneRegister" @click="changeMethod(2)">{{$t('register.emailRegister')}}</div>-->
<!--      <div class="item other" v-if="!isPhoneRegister" @click="changeMethod(1)">{{$t('register.phoneRegister')}}</div>-->

<!--      <van-password-input :value="value" :mask="false" :focused="showKeyboard" @focus="Focus" length="4" gutter="10" />-->
<!--      <div class="hqyzm">{{ $t("register.hqyzm") }}</div>-->
    </form>

    <div class="basic_btn sbtn" style="margin-top: 30px;" :class="
      data.mobile == '' || data.password == '' //||data.code == ''
        ? 'no_touch'
        : ''
    " @click="submit">
      {{ $t("register.signUpBtn") }}
    </div>
    <van-dialog v-model="statement" confirm-button-color="#fb661e" :close-on-click-overlay="true"
      @click="privacyStatementHide">
    </van-dialog>
    <van-dialog v-model="agreement" confirm-button-color="#fb661e" :close-on-click-overlay="true"
      @click="agreementHider">
    </van-dialog>
    <!-- <div
      v-if="msg_show"
      class="kefu"
      :class="show_kefu ? '' : 'kefu_hide'"
      @click="kefu_to"
    >
      <img class="kefu_img" src="../images/index/kefu.png" />
    </div> -->
<!--    <div class="kf_tips" @click="goKefu">-->
<!--      <img src="../images/index/kefu.png" alt="" />-->
<!--    </div>-->
    <van-number-keyboard v-model="value" :show="showKeyboardz" @blur="Blue()" />
  </div>
</template>

<script>
import Vue from "vue";
import { CountDown, Checkbox, Dialog } from "vant";
import Fetch from "../../utils/fetch";

Vue.use(CountDown).use(Checkbox).use(Dialog);

export default {
  name: "Register",
  data() {
    return {
      value: "",
      showKeyboard: true,
      showKeyboardz: false,
      lang: this.$i18n.locale || "en_us",
      time: 0,
      agreement: false,
      statement: false,
      show_kefu: false,
      msg_show: true,
      show_sms: 0,
      password: "password",
      data: {
        password: "",
        spassword: "",
        mobile: "",
        t_mobile: "",
        code: "",
        agent: 10000,
        email:'',
        captcha_code: '',  // 用户输入
        uuid: '',
        phone: '',
      },
      config: {},
      kf_url : '',
      isPhoneRegister:true,
      captchaImage: '',
      captchaUuid: '',

      showCountry: false,
      keyword: '',
      // 当前选择
      country: { iso2: 'ZA', name: 'South Africa', dialCode: '+27', flag: '🇿🇦' },
      // 国家数据（你可以扩充/换成完整数据文件）
      countries: [
        { iso2: 'ZA', name: 'South Africa', dialCode: '+27',  flag: '🇿🇦' },
        { iso2: 'EG', name: 'Egypt',        dialCode: '+20',  flag: '🇪🇬' },
        { iso2: 'MA', name: 'Morocco',      dialCode: '+212', flag: '🇲🇦' },
        { iso2: 'DZ', name: 'Algeria',       dialCode: '+213', flag: '🇩🇿' },
        { iso2: 'TN', name: 'Tunisia',       dialCode: '+216', flag: '🇹🇳' },
        { iso2: 'NG', name: 'Nigeria',       dialCode: '+234', flag: '🇳🇬' },
        { iso2: 'GH', name: 'Ghana',         dialCode: '+233', flag: '🇬🇭' },
        { iso2: 'SN', name: 'Senegal',       dialCode: '+221', flag: '🇸🇳' },
        { iso2: 'CI', name: 'Ivory Coast',   dialCode: '+225', flag: '🇨🇮' },
        { iso2: 'CM', name: 'Cameroon',      dialCode: '+237', flag: '🇨🇲' },
        { iso2: 'KE', name: 'Kenya',         dialCode: '+254', flag: '🇰🇪' },
        { iso2: 'TZ', name: 'Tanzania',      dialCode: '+255', flag: '🇹🇿' },
        { iso2: 'ET', name: 'Ethiopia',      dialCode: '+251', flag: '🇪🇹' }
      ],

    };
  },
  created() {
    this.$parent.footer("user", false);
    this.getparams();
    // 安卓返回IMEI，苹果返回UID值
    /*BSL.PhoneID('callName');
      window.callName = this.methodName;
      // 获取手机OAID
      BSL.GetOAID('getExternalInfo');
      window.getExternalInfo = this.getExternalInfoData; */
  },
  watch: {
    value(value) {
      if (value.length === 4) {
        this.showKeyboardz = false;
      } else {
      }
    },
  },
  computed: {
    // A-Z 索引
    indexList() {
      return Object.keys(this.filteredGrouped);
    },

    // 分组：按国家名首字母
    grouped() {
      const map = {};
      this.countries.forEach(c => {
        const letter = (c.name[0] || '#').toUpperCase();
        (map[letter] || (map[letter] = [])).push(c);
      });
      // 每组排序
      Object.keys(map).forEach(k => map[k].sort((a,b)=>a.name.localeCompare(b.name)));
      return map;
    },

    // 搜索过滤 + 分组
    filteredGrouped() {
      const kw = this.keyword.trim().toLowerCase();
      const list = !kw
              ? this.countries
              : this.countries.filter(c =>
                      c.name.toLowerCase().includes(kw) ||
                      c.dialCode.includes(kw.replace(/\s/g, '')) ||
                      c.iso2.toLowerCase().includes(kw)
              );

      const map = {};
      list.forEach(c => {
        const letter = (c.name[0] || '#').toUpperCase();
        (map[letter] || (map[letter] = [])).push(c);
      });
      Object.keys(map).forEach(k => map[k].sort((a,b)=>a.name.localeCompare(b.name)));
      return map;
    },
  },
  mounted() {
    if (this.$route.query.agent) {
      localStorage.setItem("agent", this.$route.query.agent);
      this.data.agent = this.$route.query.agent;
    } else {
      if (localStorage.getItem("agent")) {
        this.data.agent = localStorage.getItem("agent");
      }
    }
    var that = this;
    document.body.addEventListener(
      "scroll",
      function () {
        if (!that.show_kefu) {
          return;
        }
        that.show_kefu = false;
      },
      false
    );
    document.addEventListener(
      "click",
      function (ev) {
        if (ev.target.className != "kefu_img") {
          that.show_kefu = false;
        }
      },
      false
    );
    Fetch("/index/webconfig", { type: "web" }).then((res) => {
      this.config = res.data;
      this.kf_url = res.data.kefu_link;
      this.show_sms = res.data.sms_verify;
    });
    this.getCaptcha();
  },

  methods: {
    formatNumber(val) {
      return val.replace(/\D/g, '') // 只保留数字
    },
    selectCountry(item) {
      this.country = item;
      this.showCountry = false;
      this.keyword = '';
    },
    // 提交给后端：E.164 格式（+国家码 + 纯数字）
    getE164() {
      const national = (this.phone || '').replace(/\D/g, '');
      return `${this.country.dialCode}${national}`;
    },
    // 获取验证码
    getCaptcha() {
      Fetch("/index/captcha").then((res) => {
        this.captchaImage = res.data.captcha;
        this.data.uuid = res.data.uuid;   // 提交时要带上
      });
    },
    // 刷新验证码
    refreshCaptcha() {
      this.getCaptcha();
    },
    change_tp(val) {
        // 只保留数字
        let newVal = val.replace(/\D/g, '');

        // 首位不能是 0
        if (newVal.startsWith('0')) {
            newVal = newVal.replace(/^0+/, '');
        }

        // 限制长度（可选）
        newVal = newVal.slice(0, 11);

        this.data.mobile = newVal;
      },
    Focus(e) {
      console.log(e);
      this.showKeyboard = true;
      this.showKeyboardz = true;
    },
    Blue(e) {
      console.log(e);
      this.showKeyboardz = false;
    },
    goKefu() {
      window.location.href = this.kf_url;
    },
    kefu_to() {
      if (this.show_kefu) {
        this.$router.push("/kefu");
      }
      this.show_kefu = !this.show_kefu;
    },
    showPwd() {
      if (this.password == "password") {
        this.password = "text";
      } else {
        this.password = "password";
      }
    },
    methodName(r) {
      this.data.imei = r;
    },
    getExternalInfoData(info) {
      var info = JSON.parse(info);
      console.log(info);
      if (info.code == 0) {
        this.data.oaid = info.oaid;
      }
    },
    getparams() {
      var m = this.$route.query.m;
      this.data.t_mobile = m;
    },
    timeCall() {
      this.is_send = false;
      this.time = 0;
    },
    sendcode() {
      if (this.is_send) {
        return;
      }
      if(this.isPhoneRegister){
        if (!this.data.mobile) {
          this.$toast(this.$t("register.phoneEmpty"));
          return;
        }
      }else{
        if (!this.data.email) {
          this.$toast(this.$t("register.emailEmpty"));
          return;
        }

        if (!this.data.email) {
          this.$toast(this.$t("register.emailEmpty"));
          return;
        }
        var reg = /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/;
        if(!reg.test(this.data.email)){
          this.$toast(this.$t("register.mailboxError"));
          return;
        }


      }

      this.is_send = true;

      let method=this.isPhoneRegister==true?1:2;
      Fetch("/index/register_code", {
        mobile: this.data.mobile,
        email:this.data.email,
        method:method
      })
        .then(() => {
          this.time = 60 * 1000;
          this.$toast({
            background: "#07c160",
            message: this.$t("register.sendSuccess"),
          });
        })
        .catch(() => {
          this.is_send = false;
        });
    },
    submit() {
      if (!this.data.mobile) {
        this.$toast(this.$t("register.phoneEmpty"));
        return;
      }
      if (!this.data.password) {
        this.$toast(this.$t("register.passwordEmpty"));
        return false;
      }
      if (!this.data.spassword) {
          this.$toast(this.$t('Please re-enter your password.'));
          return false;
      }

      if (!this.data.email) {
        this.$toast(this.$t("register.emailEmpty"));
        return;
      }
      var reg = /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/;
      if(!reg.test(this.data.email)){
        this.$toast(this.$t("register.mailboxError"));
        return;
      }

      if (!this.data.code && this.config.sms_verify) {
        this.$toast(this.$t("register.codeEmpty"));
        return false;
      }
      if (this.data.password != this.data.spassword) {
          this.$toast(this.$t('register.passwordError'));
          return false;
      }
      if (!this.data.t_mobile) {
        this.$toast(this.$t('register.inviteEmpty'));
        return false;
      }
      if(!this.data.captcha_code) {
        this.$toast(this.$t('Please enter the CAPTCHA'));
        return false;
      }

      // 拼接账号
      const e164 = this.getE164();
      this.data.phone = e164 + this.data.mobile;

      Fetch("/index/register", {
        ...this.data,
      }).then((res) => {
        if(res.code==0){
          this.$toast(res.info);
          return;
        }
        if(res.code==102) {
          this.getCaptcha();
          this.$toast(res.info);
          return;
        }
        if (res.data.token) {
          localStorage.setItem("token", res.data.token);
        }
        this.$toast(this.$t("register.signUpSuccess"));
        this.$router.replace("/");
      });
    },
    userAgreement() {
      this.agreement = true;
    },
    agreementHider() {
      this.agreement = false;
    },
    privacyStatement() {
      this.statement = true;
    },
    privacyStatementHide() {
      this.statement = false;
    },
    changeMethod(method){
      if(method===1){
        this.isPhoneRegister=true;
      }else{
        this.isPhoneRegister=false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
  .back_left {
    position: absolute;
  }
/deep/ .van-password-input__security {
  justify-content: space-between;
  align-items: center;
}

/deep/ .van-password-input__security li {
  background-color: #f3f3f3;
  width: 30px;
  height: 30px;
  flex: 0.15;
}

.hqyzm {
  width: 80%;
  height: 25px;
  margin: 0 auto;
  background: #3f4141;
  border-radius: 10px;
  margin-top: 20px;
  font-size: 14px;
  font-family: MicrosoftYaHei;
  font-weight: bold;
  color: #ffffff;
  line-height: 25px;
  text-align: center;
}

.login_bg {
  width: 100%;
  height: 300px;
  overflow: hidden;
  background-color: #000;
  clip-path: ellipse(100% 100% at 50% 0%);
  -webkit-clip-path: ellipse(100% 100% at 50% 0%);
  position: relative;
  z-index: 1;
  padding-top: 15px;

  .language {
    position: absolute;
    top: 40px;
    right: 15px;
    height: 36px;
    img {
      height: 100%;
    }
  }
}

.title-img {
  position: absolute;
  top: 70px;
  left: 50%;
  transform: translateX(-50%);

  img {
    height: 32px;
  }
}

.basic_wrap {
  -webkit-overflow-scrolling: touch;
  background-color: #fff;
  padding-bottom: 1rem;

  .form {
    margin: -165px auto 0 auto;
    width: 90%;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 4px 9px 2px rgba(160, 160, 160, 0.15);
    border-radius: 13px;
    padding: 31px 24px 24px 24px;
    position: relative;
    z-index: 2;
  }
}

.cut_login {
  //width: 207px;
  line-height: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  text-align: center;
  margin: 0 auto;
  border-radius: 100px;
  overflow: hidden;
  background-color: #f3f3f3;
  color: #c4c5c6;

  a {
    width: 50%;
    // padding: 3px 0;
    // padding-bottom: 10px;
    color: #9e9e9e;
    position: relative;

    // .line {
    //   width: 100%;
    //   height: 1px;
    //   position: absolute;
    //   left: 0;
    //   bottom: 0;
    //   background-color: #f2f2f2;
    // }
  }

  a.cur {
    color: #fff;
    background-color: #76b900;

    .line {
      height: 2px;

      //   background-image: linear-gradient(to right, #f12211, #f18a11);
    }
  }
}

.block {
  width: 100%;
  height: 100%;
  // overflow:hidden;
  // margin: 10% auto;
  font-size: 15px;
  justify-content: center;
  background-color: #fff;
  border-radius: 5px;

  .block-title {
    display: block;
    font-weight: bolder;
    line-height: 39px;
    height: 39px;
    text-align: center;
  }

  .p_agr {
    // padding-top:30rpx;
    font-size: 12px;
    /*font-weight: bolder;*/
    line-height: 20px;
    padding: 0px 10px;
    height: 388px;
    /*overflow: hidden;*/
    // overflow: auto;
    -webkit-overflow-scrolling: touch;
    overflow-y: scroll;
  }

  .div_qd {
    width: 60px;
    height: 25px;

    span {
      width: 60px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      justify-content: center;
      background: #9b7c6d;
      border-radius: 10px;
      padding: 1px 5px;
      color: #fff;
    }

    margin: 10px auto;
  }
}

.item {
  //   border-bottom: 1px solid #f0f1f3;
  font-size: 14px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  padding-bottom: 4px;
  margin-top: 10px;

  .icon {
    width: 32px;
    height: 27px;

    img {
      width: 100%;
      height: 100%;
    }
  }

  input {
    background-color: #f3f3f3;
    border-radius: 100px;
    padding: 15px;
    height: 40px;
    flex: 1;
    margin-bottom: 3px;
  }
}

.get_captcha {
  width: 88px;
  height: 34px;
  background: linear-gradient(90deg,
  rgb(85, 155, 81) 0%,
  rgb(143, 151, 80) 100%);
  border-radius: 4px;
  text-align: center;
  line-height: 34px;
  font-size: 14px;
  color: #ffffff;
}

.protocol {
  font-size: 12px;
  line-height: 17px;
  margin-top: 20px;
  color: #999999;

  a {
    color: #3d96ff;
  }
}

.basic_btn {
  margin: 39px auto 0 auto;
  width: 80% !important;
  background: #76b900 !important;
  color: #000;
  font-weight: 700;
  font-size: 16px;
  border-radius: 10px;
}

.kf_tips{
  position: absolute;
  top: 40px;
  right: 18px;
  height: 31px;
  z-index: 9;
  img{
    height: 100%;
  }
}

.other{
  margin-left: 7px;
  text-decoration: underline;
  color:#616161;
  cursor:pointer;
  text-decoration-color: #76b900;
  text-decoration-thickness: 2px;
  text-underline-offset: 5px;
}


  .custom-input {
    background-color: #f3f3f3;
    border-radius: 100px;
    padding: 15px;
    height: 40px;
    flex: 1;
    margin-bottom: 3px;
  }
  .country-trigger{
    display:flex; align-items:center; gap:6px;
    padding-right:6px; color:#1989fa; font-size:14px;
  }
  .flag{ font-size:16px; }
  .code{ font-weight:500; }
  .country-page{ height:100%; background:#fff; }
  .country-header{ padding:12px 12px 0; }
  .cell-flag{ font-size:18px; margin-right:8px; }

</style>
